<div class="w-100">
  <div class="position-relative w-100" (document:click)="handleOutsideClick($event)">
    <!-- Clickable div to toggle dropdown -->
    <div class="d-flex justify-content-between dropdown-input input" >
      <p *ngIf="!selectedItems.length" class="mb-0">{{placeHolder}}</p>
      <div class="d-flex selected-items-container">
        <div class="item" *ngFor="let key of selectedItems">
          {{ getItemName(key) }} 
          <button class="close-btn" (click)="removeItem(key)">x</button>
        </div>
      </div>
      
      <div>
        <ion-button class="dropdown-btn" fill="clear" (click)="toggleDropdown($event)">
          <ion-icon name="chevron-down-outline"></ion-icon>
        </ion-button>
      </div>
    </div>

    <!-- Dropdown list -->
    <div class="dropdown-list-main" [ngClass]="{'dropdown-list-main-top' : dropdownOnTop}" *ngIf="dropdownVisible">
      <div class="sticky-top d-flex search-container justify-content-start align-items-center pt-1">
        <input type="checkbox" [(ngModel)]="selectAllChecked" (change)="toggleSelectAll()" *ngIf="filteredItems.length > 0">   
        <input type="text" placeholder="Search Item" [(ngModel)]="searchTerm" (input)="filterItems()">
      </div>
      <div class="dropdown-list">
        <div class="item d-flex" *ngFor="let item of filteredItems">
          <input type="checkbox" [checked]="isSelected(item.key)" (change)="toggleSelection(item)">
          <p>{{item.name}}</p>
        </div>
        <div class="item d-flex" *ngIf="filteredItems.length === 0">
          <p>No Results Found</p>
        </div>
      </div>
    </div>
  </div>
</div>
